import { stateService } from '@/services/state.service'
import { mapActions } from 'vuex'

export default {
    name: 'StateTypeDialogDataTabComponent',
    components: {},
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model del formulario
        isValidForm: false,
        // errores para los textfields de locales
        esTextfieldErrors: [],
        enTextfieldErrors: [],
        ptTextfieldErrors: [],
        frTextfieldErrors: []
    }),
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            if (this.$refs.stateTypeDialogForm) {
                this.$refs.stateTypeDialogForm.reset()
            }
        },
        /**
         * Valida una traducción con las demás existentes en la collection
         * @param {*} translation
         * @param {*} locale
         */
        async validateTranslation(translation, locale) {
            // true si se puede usar, false en caso contrario
            const validation = await stateService.validateTranslation(locale, translation, this.model._id)

            // agrego/limpio el mensaje de error en el textfield correspondiente
            switch (locale) {
                case 'es':
                    if (!validation) {
                        this.esTextfieldErrors = []
                        this.esTextfieldErrors.push(this.$t('stateType.error.invalidNameES'))
                    } else {
                        this.esTextfieldErrors = []
                    }
                    break;
                case 'en':
                    if (!validation) {
                        this.enTextfieldErrors = []
                        this.enTextfieldErrors.push(this.$t('stateType.error.invalidNameEN'))
                    } else {
                        this.enTextfieldErrors = []
                    }
                    break;
                case 'pt':
                    if (!validation) {
                        this.ptTextfieldErrors = []
                        this.ptTextfieldErrors.push(this.$t('stateType.error.invalidNamePT'))
                    } else {
                        this.ptTextfieldErrors = []
                    }
                    break;
                case 'fr':
                    // el francés es opcional: si está vacío no hay nada que validar
                    if (translation && !validation) {
                        this.frTextfieldErrors = []
                        this.frTextfieldErrors.push(this.$t('stateType.error.invalidNameFR'))
                    } else {
                        this.frTextfieldErrors = []
                    }
                    break;
                default:
                    console.error('Locale no implementado!')
            }
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.stateTypeDialogForm) {
                this.$refs.stateTypeDialogForm.resetValidation()
            }
        }
    }
}
